var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAlanbase = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9457 42.5H22.1052V22.6252C34.6218 23.4756 41.9481 33.9294 41.9457 42.5ZM22.1151 0.534509C22.083 0.68487 22.0186 0.840161 22.0186 0.995452C22.0137 7.39688 22.0137 13.7983 22.0137 20.3033H41.9976C41.5917 9.68434 32.565 0.877135 22.1151 0.534509ZM0.00753686 22.6499C-0.15582 31.9821 8.55406 42.2338 19.7217 42.4039C19.7217 35.8225 19.7217 29.2436 19.7217 22.6499H0.00753686ZM19.6994 20.3205H0.00506175C-0.235023 12.5979 6.69031 1.35287 19.6994 0.5V20.3205ZM17.2268 10.4164C17.2268 9.49208 16.3432 8.59238 15.42 8.57759C14.472 8.5628 13.6156 9.39102 13.5859 10.3548C13.5562 11.3432 14.3235 12.1813 15.2987 12.2257C16.3209 12.2725 17.2293 11.4197 17.2268 10.4164Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAlanbase);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_alanbase.4e2ebf5b3335fec81ce0a68b3b3de624.svg";